export default "__VITE_ASSET__QtT1GoAu__"